import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=65279576&scoped=true&"
import script from "./dataItem.vue?vue&type=script&lang=js&"
export * from "./dataItem.vue?vue&type=script&lang=js&"
import style0 from "./dataItem.vue?vue&type=style&index=0&id=65279576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65279576",
  null
  
)

export default component.exports